import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PasswordErrors } from '../../forms/validators';

const RULES = ['numbers', 'mixedCase', 'specialChars', 'length'] as const;

@Component({
  selector: 'app-password-tips',
  imports: [TranslatePipe],
  templateUrl: './password-tips.html',
  styleUrl: './password-tips.scss',
})
export class PasswordTips {
  readonly errors = input.required<PasswordErrors | null>();
  /** Tips only react once the password has a value. */
  readonly active = input.required<boolean>();
  readonly open = input.required<boolean>();

  protected readonly rules = RULES;

  protected readonly loaderWidth = computed(() => {
    if (!this.active()) {
      return '0';
    }
    const passed = RULES.filter((rule) => this.isValid(rule)).length;
    return `${Math.round((100 / RULES.length) * passed)}%`;
  });

  protected isValid(rule: (typeof RULES)[number]) {
    return this.active() && !this.errors()?.[rule];
  }
}
